export const THIRD_PARTY_CHANNEL_TYPE_51 = '51job'
export const THIRD_PARTY_CHANNEL_TYPE_FACEBOOK = 'facebook'
export const THIRD_PARTY_CHANNEL_TYPE_LINKEDIN = 'linkedIn'
export const THIRD_PARTY_CHANNEL_TYPE_JOBSTREET = 'jobstreet'
export const THIRD_PARTY_LOGIN_STATUS_MAPPING = {
  needVerifyCode: {
    i18nKey: 'needVerifyCode'
  },
  UserNameOrPwdError: {
    i18nKey: 'UserNameOrPwdError'
  },
  UserMobileRequired: {
    i18nKey: 'UserMobileRequired'
  },
  loginErrToManyTimes: {
    i18nKey: 'loginErrToManyTimes'
  },
  tryLater: {
    i18nKey: 'tryLater'
  },
  loadResumeFailed: {
    i18nKey: 'loadResumeFailed'
  },
  confirmation_account: {
    i18nKey: 'confirmationAccount'
  },
  needPhoneBinding: {
    i18nKey: 'needPhoneBinding'
  },
  input_account_format_error: {
    i18nKey: 'inputAccountFormatError'
  },
  password_short: {
    i18nKey: 'passwordShort'
  },
  needFetchSMSCode: {
    i18nKey: 'needFetchSMSCode'
  },
  smsCodeError: {
    i18nKey: 'smsCodeError'
  }
}
